const TagAssignmentEndpoints = {
  EXECUTE_TAG_ASSIGNMENT: "/voc-tag-assignment-runs/",
  GET_TAG_ASSIGNMENT_RUNS: "/voc-tag-assignment-runs/",
};

export default TagAssignmentEndpoints;
